require('./block/animation.js');
require('./block/menu.js');
require('./block/mobileMenu');
require('./block/apply');
require('./block/file');
require('./block/about');
require('./block/header');
require('./block/faq');

$(function () {
	$('.js-header').each(function () {
		let obj = $(this);
		let text = obj.text().trim().split(' ');
		text = text.map(t => '<span>' + t + '</span>');
		obj.html(text.join(' '));
	});
});